import React from "react";
import { Button, Modal, Upload, Spin } from "antd";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

export default function AddPhoto(props) {
  const {
    loading,
    photo,
    setPhoto,
    visible,
    addPhotoToPerson,
    onClose
  } = props;

  return (
    <Modal
      title="Add More Photo"
      visible={visible}
      footer={null}
      onCancel={onClose}
    >
      <Spin spinning={loading}>
        {photo ? (
          <>
            <img
              alt=""
              style={{ width: "100%", borderRadius: 6, marginBottom: 12 }}
              src={photo}
            />
            <Button style={{marginRight: "5px"}} type="primary" onClick={() => addPhotoToPerson(photo)}>
              Register Photo
            </Button>
            <Button type="danger" onClick={() => setPhoto(null)}>
              Clear Photo
            </Button>
          </>
        ) : null}
        {visible && !photo && (
          <Camera
            onTakePhotoAnimationDone={dataUri => {
              setPhoto(dataUri);
            }}
            isImageMirror={true}
          />
        )}
        {/* <Upload
          accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
          showUploadList={false}
          beforeUpload={file => {
            const reader = new FileReader();
            reader.onloadend = () => {
              setPhoto(reader.result);
            };
            reader.readAsDataURL(file);
            return false;
          }}
        >
          <Button>Upload from file</Button>
        </Upload> */}
      </Spin>
    </Modal>
  );
}

